import React, { createContext, useContext, useState, ReactNode } from 'react';

export interface SandboxContextType {
  isSandboxMode: boolean;
  telemetry: any;
  setTelemetry: (data: any) => void;
}

const defaultContext: SandboxContextType = {
  isSandboxMode: false,
  telemetry: {},
  setTelemetry: () => {}
};

const SandboxContext = createContext<SandboxContextType>(defaultContext);

export interface SandboxProviderProps {
  children: ReactNode;
  isSandboxMode?: boolean;
}

export const SandboxProvider: React.FC<SandboxProviderProps> = ({
  children,
  isSandboxMode = false
}) => {
  const [telemetry, setTelemetry] = useState<any>({});

  return (
    <SandboxContext.Provider value={{ isSandboxMode, telemetry, setTelemetry }}>
      {children}
    </SandboxContext.Provider>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export const useSandbox = () => {
  return useContext(SandboxContext);
};
